// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Sidebar-styles .ant-menu-dark,
.Sidebar-styles{
    background-color: #FF7D4D !important;
}

.ant-menu li{
    height: 56px;
}

.Sidebar-styles li{
    margin-bottom: 10px !important;

}

.Sidebar-styles .ant-menu-item svg{
    width: 31px !important;
    height: 24px !important;
}
.Sidebar-styles .ant-menu-item-selected {
    background-color: #E365369C !important;
}

.Sidebar-styles .ant-menu-dark .ant-menu-item, 
.Sidebar-styles .ant-menu-dark .ant-menu-submenu-title {
    color: #fff;
}

.Sidebar-styles .ant-menu-item:hover, 
.Sidebar-styles .ant-menu-submenu-title:hover {
    color: #000; 
}

.Sidebar-styles .ant-menu-title-content{
 font-size: 16px !important;
}`, "",{"version":3,"sources":["webpack://./src/Assets/Sidebar.css"],"names":[],"mappings":"AAAA;;IAEI,oCAAoC;AACxC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,8BAA8B;;AAElC;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;AACA;IACI,sCAAsC;AAC1C;;AAEA;;IAEI,WAAW;AACf;;AAEA;;IAEI,WAAW;AACf;;AAEA;CACC,0BAA0B;AAC3B","sourcesContent":[".Sidebar-styles .ant-menu-dark,\r\n.Sidebar-styles{\r\n    background-color: #FF7D4D !important;\r\n}\r\n\r\n.ant-menu li{\r\n    height: 56px;\r\n}\r\n\r\n.Sidebar-styles li{\r\n    margin-bottom: 10px !important;\r\n\r\n}\r\n\r\n.Sidebar-styles .ant-menu-item svg{\r\n    width: 31px !important;\r\n    height: 24px !important;\r\n}\r\n.Sidebar-styles .ant-menu-item-selected {\r\n    background-color: #E365369C !important;\r\n}\r\n\r\n.Sidebar-styles .ant-menu-dark .ant-menu-item, \r\n.Sidebar-styles .ant-menu-dark .ant-menu-submenu-title {\r\n    color: #fff;\r\n}\r\n\r\n.Sidebar-styles .ant-menu-item:hover, \r\n.Sidebar-styles .ant-menu-submenu-title:hover {\r\n    color: #000; \r\n}\r\n\r\n.Sidebar-styles .ant-menu-title-content{\r\n font-size: 16px !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
